import { render, staticRenderFns } from "./FacebookConfig.vue?vue&type=template&id=69f948ad&scoped=true"
import script from "./FacebookConfig.vue?vue&type=script&lang=js"
export * from "./FacebookConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f948ad",
  null
  
)

export default component.exports